/* ==========================================================================
   Visotale — Global JavaScript
   ========================================================================== */

(function() {
  'use strict';

  // ==========================================================================
  // Scroll reveal animation
  // ==========================================================================
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.vt-reveal').forEach(function(el) {
      revealObserver.observe(el);
    });
  } else {
    // Fallback for old browsers
    document.querySelectorAll('.vt-reveal').forEach(function(el) {
      el.classList.add('is-visible');
    });
  }

  // ==========================================================================
  // Mobile drawer
  // ==========================================================================
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileDrawer = document.querySelector('[data-mobile-drawer]');
  const drawerOverlay = document.querySelector('[data-drawer-overlay]');
  const drawerClose = document.querySelectorAll('[data-drawer-close]');

  function openMobileDrawer() {
    if (mobileDrawer) mobileDrawer.classList.add('is-active');
    if (drawerOverlay) drawerOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileDrawer() {
    if (mobileDrawer) mobileDrawer.classList.remove('is-active');
    if (drawerOverlay) drawerOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', openMobileDrawer);
  }

  drawerClose.forEach(function(btn) {
    btn.addEventListener('click', closeMobileDrawer);
  });

  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeMobileDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMobileDrawer();
  });

  // ==========================================================================
  // Cart toggle (placeholder - will be wired to cart drawer in Phase 3)
  // ==========================================================================
  const cartToggle = document.querySelector('[data-cart-toggle]');
  if (cartToggle) {
    cartToggle.addEventListener('click', function(e) {
      e.preventDefault();
      // Will open cart drawer in Phase 3
      window.location.href = window.routes.cart_url;
    });
  }

  // ==========================================================================
  // Header scroll behavior
  // ==========================================================================
  let lastScroll = 0;
  const header = document.querySelector('.vt-header');
  window.addEventListener('scroll', function() {
    const current = window.pageYOffset;
    if (header) {
      if (current > 10) {
        header.style.boxShadow = '0 1px 3px rgba(0,0,0,0.04)';
      } else {
        header.style.boxShadow = 'none';
      }
    }
    lastScroll = current;
  }, { passive: true });

  // ==========================================================================
  // Update cart count (global helper for other modules)
  // ==========================================================================
  window.VisotaleCart = window.VisotaleCart || {};
  window.VisotaleCart.updateCount = function(count) {
    const cartCount = document.querySelector('[data-cart-count]');
    if (!cartCount) return;
    cartCount.textContent = count;
    if (count > 0) {
      cartCount.classList.remove('is-empty');
    } else {
      cartCount.classList.add('is-empty');
    }
  };
})();
